import React, { Component } from 'react';
import {
    Bar,
    BarChart,
    CartesianGrid,
    Cell,
    ResponsiveContainer,
    Tooltip,
    XAxis,
    YAxis
} from 'recharts';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

import IconTicketTotal from '../../assets/icons/IconTicketTotal';

const COLORS_OVERVIEW = ["#2E90FC", "#1D53A5"];

class TicketOverviewChartPrincipal extends Component {
    render() {
        return (
            <>
                {/* Overview */}
                <div className="rounded-md shadow-lg relative col-span-4 row-span-2 bg-white h-96">
                    <div className="text-nexcareblue1 p-3">
                        <div className="flex justify-between pt-3">
                            {
                                this.props.loading ?
                                    <Skeleton height={20} width={100} />
                                    :
                                    <p className="text-xl font-bold">Overview</p>
                            }
                            {
                                this.props.loading ?
                                    <Skeleton height={20} width={100} />
                                    :
                                    <div className="text-gray-700 text-base font-semibold flex">
                                        <div className="mt-2 mr-3"> <IconTicketTotal /> </div>
                                        <p> Total Tiket </p>
                                    </div>
                            }
                        </div>
                    </div>

                    {
                        this.props.loading
                            ? <div className="px-3 h-72"><Skeleton height="100%" /></div>
                            : <div>
                                {
                                    this.props.data.length > 0
                                        ? <div className="w-full h-64">
                                            <ResponsiveContainer width="100%" height="100%">
                                                <BarChart
                                                    data={this.props.data}
                                                    onClick={this.props.handlePopupTicketOverview}
                                                    margin={{
                                                        top: 5,
                                                        bottom: 0,
                                                        left: -10,
                                                        right: 15,
                                                    }}
                                                >
                                                    <CartesianGrid strokeDasharray="1 1" />
                                                    <XAxis dataKey="name" minTickGap={2} />
                                                    <YAxis />
                                                    <Tooltip />
                                                    <Bar dataKey="ticket" fill="#8884d8">
                                                        {this.props.data.map((entry, index) => (
                                                            <Cell id="btnoverview" key={`cell-${index}`} fill={COLORS_OVERVIEW[index % 2]} />
                                                        ))}
                                                    </Bar>
                                                </BarChart>
                                            </ResponsiveContainer>
                                        </div>
                                        : <div className="w-full h-72 flex justify-center items-center text-lg font-medium">
                                            <p className="text-darkgrey">Tidak ada data</p>
                                        </div>
                                }
                            </div>
                    }
                </div>
            </>
        );
    }
}

export default TicketOverviewChartPrincipal;